<div class="nav-tab__content">
  <ng-content />
</div>
